module.exports = __webpack_public_path__ + "static/media/PCModal.9bc65562.svg";